interface Community {
  communityName: string;
  coverageStart?: Date;
  buildingId?: string;
  building: {
    yearBuilt: number;
    zipCode: string;
    addressState: string;
    addressCity: string;
    addressStreet: string;
  };
}

export const CREATE_COMMUNITY = (community: Community) => {
  const date = community.coverageStart
    ? new Date(community.coverageStart).toISOString().split('T')[0]
    : '';
  return `mutation {
        createCommunity(
          input : {
          communityName: "${community.communityName}",
          propertyManagerName: "The Guarantors",
          coverageStart: "${date}",
          communityIsGated: false,
          numberOfUnits: 100,
          buildingId: "${community.buildingId || ''}",
          building: {
            yearBuilt: ${community.building.yearBuilt},
            zipCode: "${community.building.zipCode}",
            addressState: "${community.building.addressState}",
            addressCity: "${community.building.addressCity}",
            addressStreet: "${community.building.addressStreet}",
          }
        }){
          ... on CreateCommunityOuput {
            communityId
          }
          ... on ErrorListOutput {
            errors: errors {
                type
                message
            }
            }
        }
      }`;
};
